import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DataService } from '../../../shared/dataservice.service';
import { PlanningIP, SaveStatusObj, SSOStatus, SOModule, SaveEventType, SalesOrder, ValidationItem, ValidationSummary, ActualDateChange, PlannedDateToken, ActualDateToken, RequestDateToken, configDefs, SerialData } from '../../../shared/misc-classes';
import { ValidationDialog } from '../../../dialogs/validation-dialog/validation-dialog';
import { ActualDateDialog } from '../../../dialogs/actual-date-dialog/actual-date-dialog';
import { HttpErrorResponse } from '@angular/common/http';

import { Moment } from 'moment';
import { SerialImportDialog } from '../../../dialogs/serial-import-dialog/serial-import-dialog';
import { LineItemImportDialog } from '../../../dialogs/line-item-import-dialog/line-item-import-dialog';
import { SerialDataImportDialog } from '../../../dialogs/serial-data-import-dialog/serial-data-import-dialog';
import { SAPFetchResultDialog, SAPTableColumn, SAPFetchResultData } from '../../../dialogs/sap-fetch-result-dialog/sap-fetch-result-dialog';

@Component({
  selector: 'planning',
  templateUrl: './planning.component.html',
  styleUrls: ['./planning.component.css']
})
export class PlanningComponent implements OnInit, OnChanges {

  @Input() planningObj: PlanningIP;
  @Input() soLockObtained: boolean;
  @Input() loadCounter: SalesOrder;
  @Output() updateSubSalesOrder: EventEmitter<SaveStatusObj> = new EventEmitter();
  disableForm: boolean = true;
  inputDisableMessage: string = '';
  modifyReqDate: boolean = false;
  modifyPlanDate: boolean = false;
  Hvr: any = {};

  constructor(public _dataService: DataService, public dialog: MatDialog) { }

  ngOnInit() {
    this.modifyPlanDate = this._dataService.modifyPlanDate;
    this.modifyReqDate = this._dataService.modifyReqDate;
    this.ngOnChanges();
  }
  ngOnChanges() {
    this.disableForm = true;
    if (this.soLockObtained == false) {
      this.inputDisableMessage = "You can't Edit, Sale Order Lock NOT obtained.";
    }
    else if (!this.planningObj.isProjectLive) {
      this.inputDisableMessage = "Project is on HOLD or TO BE CANCELLED";
    }
    else if (!this.planningObj.isInputEnabled) {
      this.inputDisableMessage = "This form is not yet enabled";
    }
    else if (!this._dataService.hasPlanningEditAccess) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
    }
  }
  deleteSSo(_deleteSO: boolean) {
    if (this.updateSubSalesOrder) {
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Delete_SubSale_Order));
    }
  }

  saveSso(_submitToNextSection: boolean) {
    let ssoSubmitTo: SSOStatus = SSOStatus.Not_Started;

    if (_submitToNextSection == true) {
      ssoSubmitTo = SSOStatus.Material_Receipt | SSOStatus.Store | SSOStatus.Production;
    }
    if (this.updateSubSalesOrder) {
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders,
        (_submitToNextSection == true ? SaveEventType.Submit_To_Next : SaveEventType.Save_Data),
        null,
        ssoSubmitTo
      ));
    }
  }

  showSsoValidation() {
    let _validList: Array<ValidationItem> = [];
    //new ValidationItem("Requested Line Loading Date", (this.planningObj.requestedLineLoadingDate ? true : false)," required to move material receipt, store & production." )
    _validList.push(new ValidationItem("Submission from Engg Procurement & PO", this.planningObj.readyForMRSP, " required to move material receipt, store & production."));
    _validList.push(new ValidationItem("Line items ", (this.planningObj.lineItems.length > 0 ? true : false), " required to move material receipt, store & production."));

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);

    this.dialog.open(ValidationDialog, {
      width: '50%',
      data: vSummaryObj
    });
  }

  reloadData() {
    if (this.updateSubSalesOrder) {
      this.updateSubSalesOrder.emit(new SaveStatusObj(SOModule.Sub_Orders, SaveEventType.Reload_Data));
    }
  }
  requestDateChangeHandler(_reqDateHeader: string, _reqTokenKeyName: string, _plndReqDate: Date, _reqDateChanged: Date): void {
    // if(_plndReqDate == null){
    //   this.planningObj[_reqTokenKeyName].requestDate = _reqDateChanged;
    //   return;
    // }
    let _plndDateChangeObj: ActualDateChange = new ActualDateChange("Why is the request date changed ?", _reqDateHeader + "(existing)",
      _plndReqDate, _reqDateHeader + "(edited)", _reqDateChanged, this.planningObj[_reqTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _plndDateChangeObj
    });
    let _prevActualDate: Date = this.planningObj[_reqTokenKeyName].actualDate;
    this.planningObj[_reqTokenKeyName].requestDate = _reqDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.planningObj[_reqTokenKeyName].actualDate = _plndDateChangeObj.actualDate;

        var changedDate: Date = null;
        if (_plndDateChangeObj.actualDate != null) {
          changedDate = new Date(_plndDateChangeObj.actualDate.getTime());
        }
        this.planningObj[_reqTokenKeyName] =
          new RequestDateToken(changedDate, true, null, _plndDateChangeObj.comments, this._dataService.userId);
      }
      else {
        this.planningObj[_reqTokenKeyName].requestDate = _prevActualDate;
      }
    });
  }

  plannedDateChangeHandler(_plndDateHeader: string, _plndTokenKeyName: string, _plndDate: Date, _plndDateChanged: Date): void {
    let _plndDateChangeObj: ActualDateChange = new ActualDateChange("Why is the planned date changed ?", _plndDateHeader + "(existing)",
      _plndDate, _plndDateHeader + "(edited)", _plndDateChanged, this.planningObj[_plndTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _plndDateChangeObj
    });
    this.planningObj[_plndTokenKeyName].plannedDate = _plndDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.planningObj[_plndTokenKeyName] =
          new PlannedDateToken(new Date(_plndDateChanged.getTime()), true, null, _plndDateChangeObj.comments, this._dataService.userId);
      }
      else {
        this.planningObj[_plndTokenKeyName].plannedDate = _plndDate;
      }
    });
  }
  importSerials() {
    var sNoArray: Array<string> = [];
    let dialogRef = this.dialog.open(SerialImportDialog, {
      width: '85%',
      data: sNoArray
    });
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        sNoArray.forEach((_sNo: string) => {
          this.planningObj.addSerialNumber(_sNo);
        });
      }
    });
  }
  importLineItems() {
    var lineItmArray: Array<string> = [];
    let dialogRef = this.dialog.open(LineItemImportDialog, {
      width: '85%',
      data: lineItmArray
    });
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        lineItmArray.forEach((_lnItm: string) => {
          this.planningObj.addLineItem(_lnItm);
        });
      }
    });
  }
  importSerialData() {
    var sDataArray: Array<SerialData> = [];
    let dialogRef = this.dialog.open(SerialDataImportDialog, {
      width: '85%',
      data: { sDataArray: sDataArray, ssoNo: this.planningObj.parentSubSORef.pmTechSubSalesOrder.subOrderNo, soNo: this.planningObj.parentSORef.marketingIP.salesOrderNo },
    });
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        sDataArray.forEach((_sNo: SerialData) => {
          this.planningObj.addSerialData(_sNo);
        });
      }
    });
  }

  manfMonthMonthHandler(normalizedYear: Moment, datepicker: { close: () => void }) {
    this.planningObj.plannedManufacturingMonth = new Date(normalizedYear.year(), normalizedYear.month(), 1);
    datepicker.close();
  }

  actualDateChangeHandler(_actDateHeader: string, _actDate: Date, _actDateChanged: Date, _actTokenKeyName: string, _plndDateHeader: string, _plndDate: Date,): void {
    let _actDateChangeObj: ActualDateChange = new ActualDateChange("Additional Comment", _plndDateHeader, _plndDate, _actDateHeader,
      _actDateChanged, this.planningObj[_actTokenKeyName].addNotes);
    let dialogRef = this.dialog.open(ActualDateDialog, {
      width: '50%',
      data: _actDateChangeObj
    });
    let _prevActualDate: Date = this.planningObj[_actTokenKeyName].actualDate;
    this.planningObj[_actTokenKeyName].actualDate = _actDateChanged;
    dialogRef.afterClosed().subscribe((confirm) => {
      if (confirm == true) {
        this.planningObj[_actTokenKeyName].actualDate = _actDateChangeObj.actualDate;

        var changedDate: Date = null;
        if (_actDateChangeObj.actualDate != null) {
          changedDate = new Date(_actDateChangeObj.actualDate.getTime());
        }
        this.planningObj[_actTokenKeyName] =
          new ActualDateToken(changedDate, true, _plndDate, _actDateChangeObj.comments, this._dataService.userId);
      }
      else {
        this.planningObj[_actTokenKeyName].actualDate = _prevActualDate;
      }
    });
  }


  getRowSpanForSerialNos(_serialCount: number, _colPerRow: number) {
    let _rowSpan: number = 2;

    if (_serialCount > _colPerRow) {
      _rowSpan += Math.ceil(_serialCount / _colPerRow) - 1;
    }

    return _rowSpan;
  }
  getRowSpanForLineItem(_lineItemCount: number, _colPerRow: number) {
    let _rowSpan: number = 2;

    if (_lineItemCount > _colPerRow) {
      _rowSpan += Math.ceil(_lineItemCount / _colPerRow) - 1;
    }

    return _rowSpan;
  }
  addNewSerial() {
    let _refSerial: string = '';
    if (this.planningObj.serialNums && this.planningObj.serialNums.length > 0) {
      let _tmpSno: string = this.planningObj.serialNums[this.planningObj.serialNums.length - 1].sNo;
      if (_tmpSno && _tmpSno != '') {
        let convNum = parseInt(_tmpSno, 10)
        if (configDefs.isNumEmty(convNum) == false) {
          _refSerial = (convNum + 1) + '';
        }
      }
    }
    this.planningObj.addSerialNumber(_refSerial);
  }
  removeSerialNo(_index: number) {
    this.planningObj.removeSerialNumber(_index)
  }

  addNewLineItem() {
    let _refSerial: string = '';
    if (this.planningObj.lineItems && this.planningObj.lineItems.length > 0) {
      let _tmpSno: string = this.planningObj.lineItems[this.planningObj.lineItems.length - 1].lineItm;
      if (_tmpSno && _tmpSno != '') {
        let convNum = parseInt(_tmpSno, 10)
        if (configDefs.isNumEmty(convNum) == false) {
          _refSerial = (convNum + 1) + '';
        }
      }
    }
    this.planningObj.addLineItem(_refSerial);
  }
  removeLineItem(_index: number) {
    this.planningObj.removeLineItem(_index)
  }
  removeSerialData(_index: number) {
    this.planningObj.removeSerialData(_index)
  }

  fetchMaterialSAPData() {
    if (this.disableForm) {
      return;
    }

    const _soNo = this.planningObj.parentSORef &&
      this.planningObj.parentSORef.marketingIP
      ? this.planningObj.parentSORef.marketingIP.salesOrderNo
      : null;

    // const _soNo = "4203166270"; // Hardcoded for testing purposes
    const _subSoNo = this.planningObj.parentSubSORef && this.planningObj.parentSubSORef.pmTechSubSalesOrder
      ? this.planningObj.parentSubSORef.pmTechSubSalesOrder.subOrderNo : null;

    if (!_soNo) {
      this._dataService.openSnackbar('Sales Order not available', 'Close');
      return;
    }

    const startRange = (this.planningObj.sapStartRange || '').trim();
    const endRange = (this.planningObj.sapEndRange || '').trim();

    if (!startRange && !endRange) {
      this._dataService.openSnackbar(
        'Enter Start Range to fetch SAP data',
        'Close'
      );
      return;
    }

    if (!/^\d+$/.test(startRange || '')) {
      this._dataService.openSnackbar(
        'Start Range should be numeric',
        'Close'
      );
      return;
    }

    if (endRange && !/^\d+$/.test(endRange)) {
      this._dataService.openSnackbar(
        'End Range should be numeric',
        'Close'
      );
      return;
    }

    const _startNo = parseInt(startRange, 10);
    const _endNo = endRange ? parseInt(endRange, 10) : null;

    if (_endNo != null && _endNo < _startNo) {
      this._dataService.openSnackbar(
        'End Range should be greater than or equal to Start Range',
        'Close'
      );
      return;
    }

    const _msg: any = {
      SO: _soNo
    };

    if (endRange) {
      _msg.Item_Range_GE = startRange;
      _msg.Item_Range_LE = endRange;
    } else {
      _msg.LINE_NO = startRange;
    }

    // Open modal with loading state
    const columns: SAPTableColumn[] = [
      { key: 'matNo', label: 'Material No', width: '150px' },
      { key: 'serialNo', label: 'Serial No', width: '150px' },
      { key: 'itemNo', label: 'Item No', width: '120px' },
      { key: 'descp', label: 'Description', width: '200px' }
    ];

    const dialogData: SAPFetchResultData = {
      title: 'SAP Material Data',
      isLoading: true,
      loadingMessage: 'Fetching SAP material data, please wait...',
      columns: columns,
      rows: [],
      totalRecords: 0
    };

    const dialogRef = this.dialog.open(
      SAPFetchResultDialog,
      {
        minWidth: '350px',
        panelClass: 'sap-modal-dialog',
        data: dialogData
      }
    );

    // Make the SAP API call
    this._dataService
      .fetchMaterialSAPData(
        _soNo,
        _subSoNo,
        _msg
      )
      .subscribe(
        (resp: any) => {
          const _records = this.extractSapRows(resp);

          if (!_records || _records.length === 0) {
            dialogRef.componentInstance.showError();
            this._dataService.openSnackbar(
              'No SAP material data found',
              'Close'
            );
            return;
          }

          // Display fetched records in modal
          dialogRef.componentInstance.refreshData(
            _records,
            _records.length
          );

          // When dialog closes, bind the data to the component
          dialogRef.afterClosed().subscribe(() => {
            this.planningObj.serialData = [];

            _records.forEach((_row: any) => {
              this.planningObj.addSerialData(
                this.mapSerialData(_row)
              );
            });

            this._dataService.openSnackbar(
              'Material data loaded from SAP',
              'Close'
            );
          });
        },
        (_err: HttpErrorResponse) => {
          dialogRef.componentInstance.showError();
          this._dataService.openSnackbar(
            'Error while fetching SAP data',
            'Close'
          );
        }
      );
  }

  clearSerialData(): void {
    this.planningObj.serialData = [];
    this.planningObj.sapStartRange = '';
    this.planningObj.sapEndRange = '';
  }

  private extractSapRows(resp: any): Array<any> {

    if (!resp) {
      return [];
    }

    if (Array.isArray(resp.SUB_ROOT)) {
      return resp.SUB_ROOT;
    }

    if (resp.data && Array.isArray(resp.data.SUB_ROOT)) {
      return resp.data.SUB_ROOT;
    }

    const _data =
      resp && resp.data ? resp.data.data : null;

    if (_data && Array.isArray(_data.SUB_ROOT)) {
      return _data.SUB_ROOT;
    }

    if (Array.isArray(_data)) {
      return _data;
    }

    if (_data && _data.SUB_ROOT) {
      return Array.isArray(_data.SUB_ROOT)
        ? _data.SUB_ROOT
        : [_data.SUB_ROOT];
    }
    return [];
  }

  private mapSerialData(_row: any): SerialData {
    const _matNo = (_row.MATERIAL || _row.matNo || _row.matno || '').toString();
    const _serialNo = (_row.SERIAL_NO || _row.serialNo || _row.serialno || '').toString();
    const _itemNo = (_row.ITEM_NO || _row.itemNo || _row.itemno || '').toString();
    const _desc = (_row.DESCRIPTION || _row.descp || _row.description || '').toString();
    return new SerialData(_matNo, _serialNo, _itemNo, _desc);
  }
}
